export default function resizeImage(file: File, maxSize = 150): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const reader = new FileReader()

    reader.onload = (e) => {
      if (!e.target?.result) {
        return reject('Failed to load file')
      }
      img.src = e.target.result as string
    }

    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        return reject('No canvas context')
      }

      // Keep aspect ratio
      const scale = Math.min(maxSize / img.width, maxSize / img.height)
      const width = img.width * scale
      const height = img.height * scale

      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0, width, height)

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            return reject('Canvas is empty')
          }
          resolve(new File([blob], file.name, { type: 'image/jpeg' })) // or 'image/png'
        },
        'image/jpeg',
        0.9 // quality
      )
    }

    reader.readAsDataURL(file)
  })
}
